import { TDispatch, TGetState, EBuyPackageStatus } from '../../types';
import { closeBuyPackageModal, setBuyPackageModalStatus } from '../../slices';
import { selectPaymentInitSource } from '../../selectors/payment';
import { IThunkContext } from '../../types/thunk';
import { selectBuyPackageModalData, selectIsSubscription } from '../../selectors/buyPackageModal';
import { getProductType } from './utils';
import { EPaymentWidgetResultStatus } from '../../types/microfrontends/paymentWidget';
import { buyPackageWithHold } from '../buyPackageWithHold';
import { TPaymentWidgetBeforePaymentCallback } from '../../types/events/paymentWidget/beforePayment';
import { bindEvent } from '../../utils/bindEvent';
import { paymentSuccess } from '../../services/event/paymentSuccess';

export const payPackageThunk = () => async (dispatch: TDispatch, getState: TGetState, extra: IThunkContext) => {
  const { paymentWidgetMicrofrontend } = extra;
  const state = getState();

  const paymentInitSource = selectPaymentInitSource(state)!;
  const isSubscription = selectIsSubscription(state);
  const { packageId, price, internalType } = selectBuyPackageModalData(state);

  const onBeforePaymentCallback: TPaymentWidgetBeforePaymentCallback = userBalance => {
    dispatch(buyPackageWithHold(userBalance));
  };

  const onBeforePayment = bindEvent('payment-widget/before-payment', onBeforePaymentCallback);

  const result = await paymentWidgetMicrofrontend!.openPaymentModal({
    price,
    productType: getProductType(isSubscription),
    paymentInitSource,
    packageId,
  });

  document.removeEventListener('payment-widget/before-payment', onBeforePayment);

  switch (result.status) {
    case EPaymentWidgetResultStatus.Success:
      dispatch(setBuyPackageModalStatus(EBuyPackageStatus.OkWithDeposit));

      paymentSuccess(internalType, result.paymentId, result.provider);

      return;

    case EPaymentWidgetResultStatus.Fail:
      dispatch(setBuyPackageModalStatus(EBuyPackageStatus.Error));

      return;

    default:
      dispatch(closeBuyPackageModal());

      return;
  }
};
